module.exports = __webpack_public_path__ + "img/addbtn.03b2587d.svg";